<template>
  <login-main :email="emailParam">
    <nuxt-to-meta :nuxt2meta="head" />
  </login-main>
</template>

<script lang="ts">
import AuthMixin from '~/mixins/AuthMixin'
import RequireGuestMixin from '~/mixins/RequireGuestMixin'
import { ensureArray } from '~/utility/array'
import { Component, toNative, Vue, Watch } from '~/utility/pu-class-decorator'

@Component({
  layout: ({ $isDesktop }) => {
    return $isDesktop ? 'default' : 'no-navbar'
  },
  mixins: [RequireGuestMixin, AuthMixin],
})
class AccountLoginPage extends Vue {
  get head() {
    return {
      link: [
        {
          hid: 'i18n-can',
          rel: 'canonical',
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: Type $config properly
          href: `https://${this.$config.public.envUrl}${this.$route.path}`,
        },
      ],
    }
  }

  @Watch('isLoggedIn')
  onIsLoggedInChange() {
    if (this.isLoggedIn) {
      let url = ''
      if (this.$isDesktop) {
        url =
          this.nextParam ||
          (this.isManager
            ? this.$puLocalePath('/supplier2/')
            : this.$puLocalePath({ name: 'account-dashboard' }))
      } else {
        url = this.nextParam || this.$puLocalePath('/')
      }
      window.location.href = url
    }
  }

  get nextParam() {
    const param = ensureArray(this.$route.query.next)[0] || ''
    return param.startsWith('http') || param.startsWith('//') ? '' : param
  }

  get emailParam() {
    return ensureArray(this.$route.query.email)[0] || ''
  }
}

export default toNative(AccountLoginPage)
</script>
